const refetchCachedImages = async (key: string) => {
	const images = document.querySelectorAll("img");
	images.forEach((img) => {
		if (img.src.includes(key)) {
			img.src += "?t=" + new Date().getTime();
		}
	});
};

export default refetchCachedImages;
